import gql from 'graphql-tag';

export const HubActionsDropdownQuery = gql`
	query HubActionsDropdownQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			currentUser {
				isAdmin
			}
		}
	}
`;
